import { render, staticRenderFns } from "./aOffersTableRowGroup.vue?vue&type=template&id=cc30e0f8&scoped=true"
import script from "./aOffersTableRowGroup.vue?vue&type=script&lang=js"
export * from "./aOffersTableRowGroup.vue?vue&type=script&lang=js"
import style0 from "./aOffersTableRowGroup.vue?vue&type=style&index=0&id=cc30e0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc30e0f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VCol,VRow,VWindow,VWindowItem})
